<template>
<div class="navbar navbar-default navbar-static-top top_headbar_sec">
		<div class="navbar-header">
			<div class="top-left-part">
				<router-link to="/index" class="logo"><img src="../../../../static/ibcoinexx/img/backend/finpro_logo.png" alt="" /></router-link>
			</div>
			<div class="top-center-sec">
				<div class="navbar-default sidebar side_bottom_navbar_sec clickThis" role="navigation">
					<div class="sidebar-nav navbar-collapse slimscrollsidebar">
						<ul class="nav" id="side-menu">
							<li>
								<router-link :to="'/index'"><img src="img/frontend/dashboard_icon.png" alt="" /><i class="fa fa-dashboard"></i><span class="hide-menu">Dashboard</span></router-link>
							</li>
							<li>
								<a href="#" class="ib_pop one" v-on:click.prevent="ib = !ib">
									<img src="img/frontend/deposit_withdraw_icon.png" alt="" /><i class="fa fa-cogs"></i><span class="hide-menu">IB Tools<span class="fa arrow"></span></span>
								</a>
								<ul class="nav nav-second-level dropdown-menu" v-show="ib">
									<!--<li><router-link to="/brief-report">Commission Report</router-link></li>
									<li><router-link to="/commission-withdrawals">Commission Withdrawals</router-link></li>-->
									<li><router-link to="/referral-links">Referral Links</router-link></li>
								</ul>
							</li>
							<li>
								<a href="#" class="clientdetails_pop one" @click.prevent="clientdetails = !clientdetails">
									<img src="img/frontend/deposit_withdraw_icon.png" alt="" /><i class="fa fa-users"></i><span class="hide-menu">Client Details<span class="fa arrow"></span></span>
								</a>
								<ul class="nav nav-second-level dropdown-menu" v-show="clientdetails">
									<li><router-link to="/leads-listing">Clients</router-link></li>
									<li><router-link to="/trading-listing">Trading Account</router-link></li>
									<li><router-link to="/deposits-listing">Deposits</router-link></li>
									<li><router-link to="/withdrawals-listing">Withdrawal</router-link></li>
									<li><router-link to="/sub-ib-listing">Sub Ib</router-link></li>
									<li><router-link to="/commission-listing">Commission History</router-link></li>
									<!-- <li><router-link to="/logs-listing">Logs</router-link></li> -->
								</ul>
							</li>
							<li>
								<router-link to="/commission-request" class="clientdetails_pop" @click.prevent="clientdetails = !clientdetails">
									<img src="img/frontend/deposit_withdraw_icon.png" alt="" /><i class="fa fa-users"></i><span class="hide-menu">Commission Request<span class="fa arrow"></span></span>
								</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="top-right-part">
				<a href="javascript:void(0)" class="navbar-toggle hidden-sm hidden-md hidden-lg pull-left two"  data-toggle="collapse" data-target=".navbar-collapse" @click="showDivFun()"><i class="fa fa-list"></i></a>
				<div class="top_right_sec">
					<ul class="pull-right">
						<li class="dropdown">
							<a href="#" class="dropdown-toggle profile_pop" @click.prevent="profiledrop = !profiledrop">
								<span>Welcome {{get_user.username}}<i class="fa fa-caret-down"></i></span>
							</a>
							<ul class="dropdown-menu right_drop_menusec" v-show="profiledrop">
								<li>
									<router-link to="/profile"><i class="fa fa-user"></i><span class="hide-menu">Profile</span></router-link>
								</li>
								<li>
									<router-link to="/changepassword"><i class="fa fa-refresh"></i><span class="hide-menu">Change Password</span></router-link>
								</li>
								<li>
									<a  href="#" @click="logout()"><i class="fa fa-sign-out"></i><span class="hide-menu">Logout</span></a>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as types from '@/types'
    import { mapActions } from 'vuex'
	import { fxViewMixins } from '@/plugins/fxView'
	export default {
		name: 'Header',
		mixins: [fxViewMixins],
		data(){
			return{
				ib: false,
				clientdetails: false,
				profiledrop: false
			}
		},
		methods:{
			
			...mapActions({
                _runUserLogout: types.RUN_USER_LOGOUT
            }),
			logout(){
				localStorage.setItem("last_route", this.$route.path)
                let input_json={
                    'globalParams' :{},
                    'localParams' :{
                        "parameter" : this
                    }
                }
                this._runUserLogout(input_json)
            },
			hideshow(ww){
				if (ww < 767) {
					$('.clickThis').addClass("hide");
					$('.clickThis').removeClass("show");
				} else if (ww >= 767) {
					$('.clickThis').removeClass("hideMenu");
					$('.clickThis').addClass("showMenu");
				};
			},
			showDivFun(){
				if ($('.clickThis').hasClass("hide")){
					$('.clickThis').removeClass("hide");
					$('.clickThis').addClass("show");
				}else{
					$('.clickThis').addClass("hide");
					$('.clickThis').removeClass("show");
				} 
			}
		},
		mounted() { 
			const _that = this
            $(document).on("click", function(event){
				if(!$(event.target).closest('.ib_pop').length){
                    _that.ib = false
                }
				if(!$(event.target).closest('.clientdetails_pop').length){
                    _that.clientdetails = false
                }
				if(!$(event.target).closest('.profile_pop').length){
                    _that.profiledrop = false
                }
            });
			
			
			jQuery(document).ready(function($) {
			  var alterClass = function() {
				var ww = document.body.clientWidth;
				_that.hideshow(ww)
			  };
			  $(window).resize(function(){
				alterClass();
			  });
			  alterClass();
			});
			
			$(document).on('click', function (event) {
			  if (!$(event.target).closest('.one').length && !$(event.target).closest('.two').length) {
				var ww = document.body.clientWidth;
				_that.hideshow(ww)	
			  }
			});
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/header.vue